import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { driverSchema } from '../schemas/driver.schema';

/**
 * Returns a paginated response for Drivers
 * @param params Paged Collection Params
 * @returns Paged Collection of Drivers
 */
export function getDrivers(this: unknown, params?: PagedCollectionParams) {
  const requestUrl = `${fleetEnvironment.resolve(this).driversUrl}?${
    params ? params.urlParams : ''
  }`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(driverSchema)));
}
